/** The Fias Forge internal arche's id — the `/a/<id>` route every forge page lives under. */
export const FORGE_ARCHE_ID = 'arche_forge';
